module.exports = __webpack_public_path__ + "img/qrcode_for_gh_696ded1be10d_258.c287d073.jpg";